var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountBirth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 71",
    style: {
      enableBackground: "new 0 0 350 71"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9FA0A0;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "discount_coupon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 562.5 1218)",
    style: {
      fontFamily: "'AdobeMyungjoStd-Medium-KSCpc-EUC-H'",
      fontSize: 12
    }
  }, "item"), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M350,17.6V2.4c0-1.3-1.1-2.4-2.4-2.4H2.4C1.1,0,0,1.1,0,2.4c0,0,0,0,0,0v15.2c0,0,9.9,4.1,9.9,17.9 S0,53.4,0,53.4v15.2C0,69.9,1.1,71,2.4,71c0,0,0,0,0,0h345.2c1.3,0,2.4-1.1,2.4-2.4V53.4c0,0-9.9-4.1-9.9-17.9S350,17.6,350,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.6,56.8c-0.6,0-1-0.4-1-1V15.2c0-0.6,0.4-1,1-1c0.5,0,1,0.5,1,1v40.6C104.6,56.3,104.1,56.8,103.6,56.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.4,34.7h-3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h3c0.4,0,0.7,0.3,0.7,0.7 C37.1,34.4,36.8,34.7,36.4,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.3,22.5c-0.2,0-0.4-0.1-0.5-0.2l-3.4-3.4c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,0.7-0.3,1,0l3.4,3.4 c0.3,0.3,0.3,0.7,0,1C41.7,22.4,41.5,22.5,41.3,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.5,22.5c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1l3.4-3.4c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1 L66,22.3C65.9,22.4,65.7,22.5,65.5,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,34.7h-3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h3c0.4,0,0.7,0.3,0.7,0.7 C74.5,34.4,74.1,34.7,73.8,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.5,17.4c-0.4,0-0.7-0.3-0.7-0.7v-3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v3 C54.2,17.1,53.8,17.4,53.5,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.9,25.4c0.5,0,0.8,0.4,0.8,0.8c0,0.5-0.4,0.8-0.8,0.8c-0.5,0-0.8-0.4-0.8-0.8 C34.1,25.8,34.4,25.4,34.9,25.4 M34.9,24c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C37.1,25,36.1,24,34.9,24 L34.9,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.3,13.9c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3S60.6,13.9,61.3,13.9 M61.3,12.4 c-1.6,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8c1.6,0,2.8-1.3,2.8-2.8S62.9,12.4,61.3,12.4L61.3,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,14.5c-0.4,0-0.8-0.3-0.8-0.8V13c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v0.7 C46.6,14.2,46.3,14.5,45.9,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.9,18.2c-0.4,0-0.8-0.3-0.8-0.8v-0.7c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v0.7 C46.6,17.9,46.3,18.2,45.9,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.1,16h-0.7c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h0.7c0.4,0,0.8,0.3,0.8,0.8 C48.8,15.7,48.5,16,48.1,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.4,16h-0.7c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h0.7c0.4,0,0.8,0.3,0.8,0.8 C45.1,15.7,44.8,16,44.4,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.1,25.9c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l0.5-0.5c0.3-0.3,0.8-0.3,1.1,0 c0.3,0.3,0.3,0.8,0,1.1l-0.5,0.5C73.5,25.9,73.3,25.9,73.1,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.4,28.6c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l0.5-0.5c0.3-0.3,0.8-0.3,1.1,0 c0.3,0.3,0.3,0.8,0,1.1L71,28.3C70.8,28.5,70.6,28.6,70.4,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.6,28.6c-0.2,0-0.4-0.1-0.5-0.2l-0.5-0.5c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l0.5,0.5 c0.3,0.3,0.3,0.8,0,1.1C74,28.5,73.8,28.6,73.6,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,25.9c-0.2,0-0.4-0.1-0.5-0.2l-0.5-0.5c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l0.5,0.5 c0.3,0.3,0.3,0.8,0,1.1C71.4,25.9,71.2,25.9,71,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.2,55.6V42.9h-3v-9.4h-3.7v-2c1.7-0.2,2.2-1.7,2.2-2.9c0-1.3-1.1-2.7-2.9-4.6c0,0-2.8,2.2-2.8,4.5 c0,2,0.7,2.8,2.2,3v2h-7v-2.2c2.1-0.2,2.7-1.9,2.7-3.3c0-1.5-1.3-3.1-3.3-5.3c0,0-3.2,2.5-3.2,5.1c0,2.3,0.8,3.2,2.5,3.4v2.2H46v-2 c1.7-0.2,2.2-1.7,2.2-2.9c0-1.3-1.1-2.7-2.9-4.6c0,0-2.8,2.2-2.8,4.5c0,2,0.7,2.8,2.2,3v2h-3.8v9.4h-3.2v12.7h-1.4v1.6h1.4h31.5 h1.5v-1.6H69.2z M60.3,28.5c0-0.9,0.8-2,1.5-2.7c0.9,1.1,1.7,2.1,1.7,2.9c0,1.7-1.1,1.7-1.4,1.7C60.6,30.3,60.3,30.2,60.3,28.5z  M51.8,27.9c0-1.1,0.9-2.3,1.7-3.1c1.1,1.2,2,2.4,2,3.3c0,1.9-1.2,1.9-1.6,1.9C52.2,30,51.8,29.7,51.8,27.9z M43.8,28.5 c0-0.9,0.8-2,1.5-2.7c0.9,1.1,1.7,2.1,1.7,2.9c0,1.7-1.1,1.7-1.4,1.7C44.2,30.3,43.8,30.2,43.8,28.5z M42.2,39.4 c0.8-0.6,1.8-1.2,2.2-1.2c0.3,0,1.3,0.7,1.9,1.2c1.2,0.9,2,1.4,2.7,1.4c0.6,0,1.3-0.5,2.4-1.3c0.7-0.5,1.7-1.3,2.2-1.3 c0.4,0,1.4,0.8,2.1,1.3c1.1,0.8,1.8,1.3,2.4,1.3c0.6,0,1.4-0.5,2.5-1.4c0.6-0.4,1.6-1.2,1.9-1.2c0.3,0,1,0.4,1.4,0.8 c0.4,0.3,0.7,0.5,1,0.6v3.3H42.2V39.4z M39.3,55.6v-5.9c0.8,0.6,1.7,1.2,2.2,1.2c0.5,0,1-0.4,2-1.1c0.7-0.5,1.7-1.2,2.1-1.2 c0.4,0,1,0.6,1.6,1c0.8,0.7,1.5,1.3,2.3,1.3c0.8,0,1.5-0.6,2.3-1.2c0.6-0.5,1.3-1.1,1.7-1.1c0.5,0,1.2,0.6,1.8,1.1 c0.7,0.6,1.4,1.2,2.1,1.2c0.6,0,1.3-0.4,2-1c0.7-0.5,1.5-1.1,2.1-1.1c0.5,0,1,0.4,1.6,0.9c0.6,0.5,1.3,1.1,2.2,1.1 c1,0,1.7-0.7,2.3-1.2c0,0,0.1-0.1,0.1-0.1v6.1H39.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountBirth);
export default __webpack_public_path__ + "static/media/discount_birth.e09842fc593293f16d4330aeee9742db.svg";
export { ForwardRef as ReactComponent };